// extracted by mini-css-extract-plugin
export default {"title":"Title_title__Z57uy","borderBottom":"Title_borderBottom__DNGJA"};